var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHashtagLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2536_550",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2536_550",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABkklEQVR4nO3cvUoDQRiF4SWFoNVMKXgFtu4B726ZabRRxCjmAg1oozbaRtakMYlbrTu7J+8DA5LmYw/HH3Y+rCoAAAAAE9HMDmvuwC7Pbo4V04Ni+lifPG8/c51bjGK6U8yrXyekW9e5xdQhvWw/cB3zq+vcYrTdqs1xnVuMCJqgrYhGE7QV0WiCtiIaTdBWRKMJ2opoNEFbEY0m6FG4OG1OFPPj5nZi7yvHAzzv7a1Nrzc1CmkxggdbjfKEtOgp5mZWh/RV/IHiSE/Inz1d+hK0hgmaHx3qCLoO+anq97o+z9e/AEbw7RrLnzqmtzqme+u1BQAAgG76408l17nFiKAJ2opoNEFbEY0maCui0QRtRTSaoK2IRhO0FdFogrYiGk3QVkSju7FNmvfd0LBNqiG3ltgmzQMFzTbpamJBs02qrmVHtkkz26QAAAD/S7xUGoYImqCtiEYTtBXRaIK2IhpN0FYU8nL3xXl6dp1bTB3S9e6/Y8hXrnOLOa+ao5+HbhsW8rL9uv3MdS4AAAAAVFPwDdWI5brF9lX2AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagLarge);
export default __webpack_public_path__ + "static/media/Hashtag Large.b745a91ed6306f8ec3a425141300098c.svg";
export { ForwardRef as ReactComponent };